import { UseGetTagAttributesReturns } from '@components/Universals/ProductItem/useTagAttributes';

import { getLabelAttributes, getSupportedCornerAttributes } from './model';
import { transformAttributesToTags } from './utils';

export const useCornerTags = ({
  attributes,
}: {
  attributes: Record<string, unknown>;
}): null | Omit<UseGetTagAttributesReturns, 'label'> => {
  if (!attributes) {
    return null;
  }

  const supportedCornerAttributes = getSupportedCornerAttributes();

  const renderableAttributes = transformAttributesToTags(attributes);

  if (renderableAttributes.length === 0) {
    return null;
  }

  const attribute = renderableAttributes.find((attr) =>
    supportedCornerAttributes.includes(attr)
  );

  if (!attribute) {
    return null;
  }

  return {
    attribute,
    ...getLabelAttributes()[attribute],
  };
};
